<script>
  export let id = -1;

  import Menu from "../components/Menu.svelte";
  import Breadcrumbs from "../components/Breadcrumbs.svelte";
  import Footer from "../components/Footer.svelte";
  import AuthorItem from "../components/AuthorItem.svelte";
  import FigureItem from "../components/FigureItem.svelte";
  import DialogCreateAuthor from "../components/DialogCreateAuthor.svelte";
  import DialogNewFigure from "../components/DialogNewFigure.svelte";
  import AcceptCancelDialog from "../components/AcceptCancelDialog.svelte";
  import LoadingDialog from "../components/LoadingDialog.svelte";
  import ArticleVersion from "../components/ArticleVersion.svelte";
  import NewArticleRevisionItem from "../components/NewArticleRevisionItem.svelte";
  import Keywords from "../components/Keywords.svelte";

  import emptyNewAuthor from "../data/emptyNewAuthor";
  import emptyNewArticle from "../data/emptyNewArticle";
  import emptyNewFigure from "../data/emptyNewFigure";

  import { loadFile } from "../utils/revista.js";
  import { dictionary } from "../utils/stores.js";
  import { getToken, redirectIfNotToken } from "../utils/token.js";
  import { post, DEBUG } from "../utils/api.js";
  import { readTextFile } from "../utils/readFile";
  import { sendEmail } from "../utils/email";
  import { randomString } from "../utils/randomString";

  import { onMount } from "svelte";

  redirectIfNotToken("/login");

  let dict;

  const unsubscribe = dictionary.subscribe((value) => {
    dict = value;
  });

  const MAX_LONGITUD_RESUMEN = 300;

  const pageName = "autor";

  let version = id !== -1 ? 2 : 1;

  let articulo = Object.assign({}, emptyNewArticle);
  let newAutor = Object.assign({}, emptyNewAuthor);
  let newFigure = Object.assign({}, emptyNewFigure);
  let buscarEmail = "";
  let autoresText = "";
  let searchError = "";

  let aceptarAction = null;
  let dialogTitulo = "";
  let dialogTituloAceptar = "";
  let dialogTituloCancelar = "";
  let dialogText = "";

  let loading = false;
  let loadingText = "";

  let errorMsgAutor = "";
  let errorMsg = "";

  let resumenLongEN = MAX_LONGITUD_RESUMEN;
  let resumenLongES = MAX_LONGITUD_RESUMEN;

  let documento1Info = null;
  let documento1Doc = "";
  let documento1Pdf = "";
  let figurasDoc1 = [];
  let revisores = [];
  let revisionesDoc = [];

  let divErrorTituloEs;
  let divErrorTituloEn;
  let divErrorResumenEs;
  let divErrorResumenEn;

  let letterCreateUser = "";
  let letterSendArticle = "";
  let letterSendArticleChiefEditor = "";
  let letterSendArticleReviewedAuthors = "";
  let letterSendArticleReviewedReviewers = "";
  let letterSendArticleReviewedEditor = "";

  let editoresJefe = [];

  onMount(async () => {
    await obtenerEditoresJefe();

    if (id !== -1) {
      await obtenerArticulo();
      obtenerArticuloDocumentos();
    } else {
      await asignarUsuarioComoAutor();
    }

    letterCreateUser = await readTextFile("/letters/create-user.txt");
    letterSendArticle = await readTextFile("/letters/send-article.txt");
    letterSendArticleChiefEditor = await readTextFile(
      "/letters/send-article-chief-editor.txt"
    );
    letterSendArticleReviewedAuthors = await readTextFile(
      "/letters/send-article-reviewed-authors.txt"
    );
    letterSendArticleReviewedReviewers = await readTextFile(
      "/letters/send-article-reviewed-reviewers.txt"
    );
    letterSendArticleReviewedEditor = await readTextFile(
      "/letters/send-article-reviewed-editor.txt"
    );
  });

  let obtenerEditoresJefe = async () => {
    const editoresListados = await post(
      "ProcesoListarEditores",
      {
        token: getToken(),
      },
      "json"
    );
    editoresJefe = editoresListados.reduce((acc, curr) => {
      if (curr.esEditorJefe) {
        acc.push({
          email: curr.email,
        });
      }
      return acc;
    }, []);
  };

  let asignarUsuarioComoAutor = async () => {
    const response = await post(
      "PerfilUsuario",
      {
        token: getToken(),
        id: -1,
      },
      "json"
    );
    articulo.autores.push({
      id: response.id,
      email: response.email,
      nombre: response.nombreUsuario,
      apellido1: response.apellido1Usuario,
      apellido2: response.apellido2Usuario,
      institucion: response.institucionUsuario,
      firma: response.firmaUsuario,
    });
    articulo = articulo;
  };

  let obtenerArticulo = async () => {
    const articuloData = await post(
      "Articulo",
      {
        token: getToken(),
        id_articulo: id,
      },
      "json"
    );

    const autores = articuloData.documento1[0].autores.map((item) => {
      return {
        id: item.id,
        email: item.email,
        nombre: item.nombreUsuario,
        apellido1: item.apellido1Usuario,
        apellido2: item.apellido2Usuario,
        institucion: item.institucionUsuario,
        firma: item.firma,
        seleccionableRevisor: item.seleccionableRevisor,
      };
    });
    articulo = {
      id: articuloData.id,
      fechaSolicitud: articuloData.fechaSolicitud,
      titulo: articuloData.documento1[0].titulo,
      title: articuloData.documento1[0].tituloEN,
      resumen: articuloData.documento1[0].abstract,
      abstract: articuloData.documento1[0].abstractEN,
      palabrasClave: articuloData.documento1[0].palabrasClave,
      keyWords: articuloData.documento1[0].palabrasClaveEN,
      autores,
      revisores: articuloData.revisores,
      editores: articuloData.editores,
      figuras: [],
      manuscript: "",
    };

    documento1Info = articuloData.documento1[0];
    revisores = articuloData.revisores;

    articulo = articulo;

    //console.log(articulo);
  };

  let obtenerArticuloDocumentos = async () => {
    documento1Doc = await post(
      "ObtenerDocumentoArticuloDoc",
      {
        token: getToken(),
        id_documento: documento1Info.id,
      },
      "text"
    );
    documento1Doc = documento1Doc.replace(/\\/g, "").replace(/"/g, "").trim();
    documento1Doc = atob(documento1Doc);
    documento1Doc = documento1Doc.replace(/\\/g, "").replace(/"/g, "").trim();

    documento1Pdf = await post(
      "ObtenerDocumentoArticuloPdf",
      {
        token: getToken(),
        id_documento: documento1Info.id,
      },
      "text"
    );
    documento1Pdf = documento1Pdf.replace(/\\/g, "").replace(/"/g, "").trim();
    documento1Pdf = atob(documento1Pdf);
    documento1Pdf = documento1Pdf.replace(/\\/g, "").replace(/"/g, "").trim();

    for (let i = 0; i < revisores.length; i++) {
      let doc = "";
      if (revisores[i].decisionDocumento1.decision !== "") {
        doc = await post(
          "ObtenerDocumentoRevisionAutores",
          {
            token: getToken(),
            id_usuario: revisores[i].id,
            id_documento: documento1Info.id,
          },
          "text"
        );
        doc = doc.replace(/\\/g, "").replace(/"/g, "").trim();
        doc = atob(doc);
        doc = doc.replace(/\\/g, "").replace(/"/g, "").trim();
      }
      revisionesDoc.push(doc);
    }
    revisionesDoc = revisionesDoc;

    for (let i = 0; i < documento1Info.figuras.length; i++) {
      figurasDoc1.push(null);
    }
    for (let i = 0; i < documento1Info.figuras.length; i++) {
      let image = await post(
        "ObtenerFiguraArticulo",
        {
          token: getToken(),
          id_figura: documento1Info.figuras[i].id,
        },
        "text"
      );
      image = image.replace(/\\/g, "").replace(/"/g, "").trim();
      image = atob(image);
      figurasDoc1[i] = image.replace(/\\/g, "").replace(/"/g, "").trim();
      figurasDoc1 = figurasDoc1;
    }
  };

  let buscarUsuario = async () => {
    if (buscarEmail !== "") {
      const usuario = articulo.autores.find((item) => {
        if (item.email === buscarEmail) {
          return item;
        }
      });
      if (!usuario) {
        const response = await post(
          "ProcesoBuscarUsuario",
          {
            token: getToken(),
            email: buscarEmail,
          },
          "json"
        );
        if (response === -1) {
          searchError = dict["errorAutorNoEncontrado"];
        } else {
          articulo.autores.push({
            id: response.id,
            email: response.email,
            nombre: response.nombreUsuario,
            apellido1: response.apellido1Usuario,
            apellido2: response.apellido2Usuario,
            institucion: response.institucionUsuario,
            firma: response.firmaUsuario,
          });
          articulo = articulo;
          searchError = "";
        }
      }
      buscarEmail = "";
    }
  };

  let resetDialogCreateAuthor = () => {
    window.$("#createAuthorForm")[0].reset();
    window.$("#createAuthorForm div.has-error").removeClass("has-error");
    window.$("#createAuthorForm span.form-validation").text("");
  };

  let showDialogCreateAuthor = () => {
    resetDialogCreateAuthor();
    newAutor = Object.assign({}, emptyNewAuthor);
    window.$("#createAuthor").modal("show");
  };

  let closeDialogCreateAuthor = () => {
    window.$("#createAuthor").modal("hide");
  };

  let registerAuthor = async () => {
    const passwd = randomString(10);
    newAutor.password = passwd;

    const response = await post(
      "RegistroUsuario",
      {
        email: newAutor.email,
        password: newAutor.password,
        nombreUsuario: newAutor.nombre,
        apellido1Usuario: newAutor.apellido1,
        apellido2Usuario: newAutor.apellido2,
        institucionUsuario: newAutor.institucion,
        firmaUsuario: newAutor.firma,
        seleccionableRevisor: newAutor.seleccionableRevisor,
      },
      "text"
    );
    if (response !== "") {
      errorMsgAutor = response;
    } else {
      let body = letterCreateUser;
      body = body.replace(
        /%USUARIO%/g,
        newAutor.nombre + " " + newAutor.apellido1 + " " + newAutor.apellido2
      );
      body = body.replace(/%EMAIL%/g, newAutor.email);
      body = body.replace(/%PASSWORD%/g, newAutor.password);
      body = body.replace(/%INSTITUCION%/g, newAutor.institucion);
      body = body.replace(/%FIRMA%/g, newAutor.firma);
      sendEmail(newAutor.email, "Registro de nuevo usuario", body);

      buscarEmail = newAutor.email;
      await buscarUsuario();
      searchError = "";
      closeDialogCreateAuthor();
    }
  };

  let removeAuthor = (index) => {
    articulo.autores.splice(index, 1);
    articulo.autores = articulo.autores;
  };

  let moveAuthor = (from, to) => {
    const f = articulo.autores.splice(from, 1)[0];
    articulo.autores.splice(to, 0, f);
    articulo.autores = articulo.autores;
  };

  let addManuscriptDoc = () => {
    loadFile("manuscriptInputDoc", addManuscriptDocReady);
  };

  let addManuscriptDocReady = (content) => {
    articulo.manuscritoDoc = content;
  };

  let addManuscriptPdf = () => {
    loadFile("manuscriptInputPdf", addManuscriptPdfReady);
  };

  let addManuscriptPdfReady = (content) => {
    articulo.manuscritoPdf = content;
  };

  let resetDialogAddFigure = () => {
    window.$("#newFigureForm")[0].reset();
    window.$("#newFigureForm div.has-error").removeClass("has-error");
    window.$("#newFigureForm span.form-validation").text("");
  };

  let showDialogAddFigure = () => {
    resetDialogAddFigure();
    newFigure = Object.assign({}, emptyNewFigure);
    window.$("#newFigure").modal("show");
  };

  let closeDialogAddFigure = () => {
    window.$("#newFigure").modal("hide");
  };

  let addFigure = () => {
    articulo.figuras.push(newFigure);
    articulo.figuras = articulo.figuras;
    closeDialogAddFigure();
  };

  let removeFigure = (index) => {
    articulo.figuras.splice(index, 1);
    articulo.figuras = articulo.figuras;
  };

  let moveFigure = (from, to) => {
    const f = articulo.figuras.splice(from, 1)[0];
    articulo.figuras.splice(to, 0, f);
    articulo.figuras = articulo.figuras;
  };

  let checkErrors = () => {
    errorMsg = "";
    let error =
      articulo.titulo === "" ||
      articulo.title === "" ||
      articulo.resumen === "" ||
      articulo.abstract === "" ||
      divErrorTituloEs.classList.contains("has-error") ||
      divErrorTituloEn.classList.contains("has-error") ||
      divErrorResumenEs.classList.contains("has-error") ||
      divErrorResumenEn.classList.contains("has-error");
    if (error) {
      errorMsg = dict["errorCampos"];
    } else {
      if (articulo.autores.length === 0) {
        error = true;
        errorMsg = dict["errorAutores"];
      } else if (
        articulo.palabrasClave.length < 3 ||
        articulo.palabrasClave.length > 5
      ) {
        error = true;
        errorMsg = dict["errorPalabrasClaveEs"];
      } else if (articulo.keyWords.length < 3 || articulo.keyWords.length > 5) {
        error = true;
        errorMsg = dict["errorPalabrasClaveEn"];
      } else if (articulo.manuscritoDoc === "") {
        error = true;
        errorMsg = dict["errorManuscritoDoc"];
      } else if (articulo.manuscritoPdf === "") {
        error = true;
        errorMsg = dict["errorManuscritoPdf"];
      }
    }
    return error;
  };

  let sendArticle = async () => {
    window.$("#acceptCancelDialogModal").modal("hide");
    loading = true;
    loadingText = dict["enviandoArticulo"] + "...";
    let response = null;
    if (version === 1) {
      response = await post(
        "ProcesoCrearArticulo",
        {
          token: getToken(),
          titulo: articulo.titulo,
          tituloEN: articulo.title,
          abstract: articulo.resumen,
          abstractEN: articulo.abstract,
          palabrasClave: articulo.palabrasClave,
          palabrasClaveEN: articulo.keyWords,
        },
        "json"
      );
    } else {
      response = await post(
        "ProcesoEnviarVersion2",
        {
          token: getToken(),
          id_articulo: id,
          titulo: articulo.titulo,
          tituloEN: articulo.title,
          abstract: articulo.resumen,
          abstractEN: articulo.abstract,
          palabrasClave: articulo.palabrasClave,
          palabrasClaveEN: articulo.keyWords,
        },
        "json"
      );
    }
    const idDocumento = response;
    for (let i = 0; i < articulo.autores.length; i++) {
      loadingText = loadingText =
        dict["enviandoAutores"] +
        " " +
        (i + 1) +
        " / " +
        articulo.autores.length +
        "...";
      response = await post(
        "ProcesoAnadirAutor",
        {
          token: getToken(),
          id_documento: idDocumento,
          id_autor: articulo.autores[i].id,
        },
        ""
      );
    }
    loadingText = dict["enviandoManuscritoDoc"] + "...";
    response = await post(
      "ProcesoAnadirDocumentoDoc",
      {
        token: getToken(),
        id_documento: idDocumento,
        documento: btoa(articulo.manuscritoDoc),
      },
      ""
    );
    loadingText = dict["enviandoManuscritoPdf"] + "...";
    response = await post(
      "ProcesoAnadirDocumentoPdf",
      {
        token: getToken(),
        id_documento: idDocumento,
        documento: btoa(articulo.manuscritoPdf),
      },
      ""
    );
    for (let i = 0; i < articulo.figuras.length; i++) {
      loadingText =
        dict["enviandoFiguras"] +
        " " +
        (i + 1) +
        " / " +
        articulo.figuras.length +
        "...";
      response = await post(
        "ProcesoAnadirFigura",
        {
          token: getToken(),
          id_documento: idDocumento,
          figura: btoa(articulo.figuras[i].imagen),
          descripcion: articulo.figuras[i].descripcion,
        },
        ""
      );
    }
    loadingText = dict["finalizando"] + "...";
    if (version === 1) {
      await post(
        "ProcesoEnviarVersion1",
        {
          token: getToken(),
          id_documento: idDocumento,
        },
        null
      );
    }

    if (!DEBUG) {
      for (let i = 0; i < articulo.autores.length; i++) {
        const autor = articulo.autores[i];
        let body =
          id === -1 ? letterSendArticle : letterSendArticleReviewedAuthors;
        body = body.replace(
          /%USUARIO%/g,
          autor.nombre + " " + autor.apellido1 + " " + autor.apellido2
        );
        body = body.replace(/%TITULO%/g, articulo.titulo);
        await sendEmail(
          autor.email,
          id === -1
            ? "Envío de nuevo artículo"
            : "Envío de nueva versión de artículo",
          body
        );
      }

      if (id !== -1) {
        for (let i = 0; i < articulo.revisores.length; i++) {
          const revisor = articulo.revisores[i];
          if (revisor.aceptado === "Si") {
            let body = letterSendArticleReviewedReviewers;
            body = body.replace(/%TITULO%/g, articulo.titulo);
            await sendEmail(
              revisor.email,
              "Nueva versión de artículo para revisión",
              body
            );
          }
        }

        for (let i = 0; i < articulo.editores.length; i++) {
          const editor = articulo.editores[i];
          if (editor.aceptado === "Si") {
            let body = letterSendArticleReviewedEditor;
            body = body.replace(
              /%USUARIO%/g,
              editor.nombreUsuario +
                " " +
                editor.apellido1Usuario +
                " " +
                editor.apellido2Usuario
            );
            body = body.replace(/%TITULO%/g, articulo.titulo);
            await sendEmail(
              editor.email,
              "Nueva versión de artículo para revisión",
              body
            );
          }
        }
      } else {
        for (let i = 0; i < editoresJefe.length; i++) {
          const editorJefe = editoresJefe[i];
          let body = letterSendArticleChiefEditor;
          body = body.replace(/%TITULO%/g, articulo.titulo);
          await sendEmail(
            editorJefe.email,
            "Nueva versión de artículo para revisión",
            body
          );
        }
      }
    }

    location.href = "/enviar-articulo-ok";
  };

  $: if (articulo) {
    const words = articulo.resumen.split(" ");
    if (words.length >= MAX_LONGITUD_RESUMEN) {
      articulo.resumen = "";
      for (let i = 0; i < MAX_LONGITUD_RESUMEN; i++) {
        articulo.resumen = articulo.resumen + words[i];
        if (i < MAX_LONGITUD_RESUMEN - 1) {
          articulo.resumen = articulo.resumen + " ";
        }
      }
      articulo = articulo;
    }
    resumenLongES = MAX_LONGITUD_RESUMEN - words.length;
  }

  $: if (articulo) {
    const words = articulo.abstract.split(" ");
    if (words.length >= MAX_LONGITUD_RESUMEN) {
      articulo.abstract = "";
      for (let i = 0; i < MAX_LONGITUD_RESUMEN; i++) {
        articulo.abstract = articulo.abstract + words[i];
        if (i < MAX_LONGITUD_RESUMEN - 1) {
          articulo.abstract = articulo.abstract + " ";
        }
      }
      articulo = articulo;
    }
    resumenLongEN = MAX_LONGITUD_RESUMEN - words.length;
  }

  $: if (articulo) {
    autoresText = articulo.autores.reduce((acc, curr, index) => {
      let text = "";
      text = text + acc + curr.firma;
      if (index < articulo.autores.length - 1) {
        text = text + " - ";
      }
      return text;
    }, "");
  }
</script>

<style>
  div.buscarAutor {
    display: flex;
    width: 100%;
    align-items: center;
  }

  div.buscarAutor div.form-wrap {
    margin-top: 0px;
  }

  div.buscarAutor input {
    min-width: 450px;
  }

  div.botonBuscar {
    margin-left: 20px;
  }

  div.listaAutores {
    margin-bottom: 20px;
    padding-left: 26px;
    padding-right: 26px;
    color: var(--revista-black);
  }

  div.crearAutor {
    margin-top: 20px;
    justify-content: flex-start;
  }

  div.anadirFigura {
    justify-content: flex-start;
  }

  div.searchError {
    margin-top: 20px;
  }

  div.info {
    color: var(--revista-black);
    text-align: justify;
    margin-bottom: 20px;
  }

  div.documento {
    margin-bottom: 40px;
  }

  div.send {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 40px;
    margin-bottom: 40px;
  }

  div.abstract {
    display: flex;
    flex-direction: column;
  }

  div.nuevaVersion {
    margin-top: 30px;
  }

  div.revisiones {
    margin-bottom: 50px;
  }

  div.tableEnd {
    width: 100%;
    height: 1px;
    background-color: lightgray;
  }

  div.errorMsg {
    margin-top: 30px;
  }
</style>

<div class="ie-panel">
  <a href="http://windows.microsoft.com/en-US/internet-explorer/">
    <img
      src="images/ie8-panel/warning_bar_0000_us.jpg"
      height="42"
      width="820"
      alt="You are using an outdated browser. For a faster, safer browsing
      experience, upgrade for free today." />
  </a>
</div>
<div class="preloader" id="loading">
  <div class="preloader-body">
    <div id="loading-center-object">
      <div class="object" id="object_four" />
      <div class="object" id="object_three" />
      <div class="object" id="object_two" />
      <div class="object" id="object_one" />
    </div>
  </div>
</div>
<div class="page">
  <!-- Menu -->

  <Menu {pageName} />

  <!-- Breadcrumbs -->

  <Breadcrumbs pageName={dict[pageName]} />

  <!-- Body -->

  <section class="section">
    <div class="container">
      <h3 class="titulo">
        {id === -1 ? dict['nuevoArticulo'] : dict['nuevaVersion']}
      </h3>
      {#if errorMsg !== ''}
        <div class="alert alert-danger errorMsg" role="alert">{errorMsg}</div>
      {/if}
      {#if id !== -1}
        <div class="alert alert-warning nuevaVersion" role="alert">
          {dict['infoNuevaVersion']}
        </div>
        <div class="revisiones">
          {#each revisionesDoc as revisionDoc, index}
            {#if revisionDoc !== ''}
              <NewArticleRevisionItem
                index={index + 1}
                decision={revisores[index].decisionDocumento1.decision}
                revisionDocAuthors={revisionDoc}
                last={false} />
            {/if}
          {/each}
        </div>
      {/if}
      <form class="rd-form rd-mailform">
        <div class="form-wrap" bind:this={divErrorTituloEs}>
          <input
            class="form-input"
            id="title-es"
            type="text"
            placeholder="Título en Español"
            data-constraints="@Required"
            bind:value={articulo.titulo} />
        </div>
        <div class="form-wrap" bind:this={divErrorTituloEn}>
          <input
            class="form-input"
            id="title-en"
            type="text"
            placeholder="Title in English"
            data-constraints="@Required"
            bind:value={articulo.title} />
        </div>
        <div class="listaAutores">{autoresText}</div>
        <div class="form-wrap abstract" bind:this={divErrorResumenEs}>
          <textarea
            class="form-input"
            id="abstract-es"
            data-constraints="@Required"
            placeholder="Resumen"
            bind:value={articulo.resumen} />
          <div class="textareaLong" placeholder>
            <span
              style="color: {resumenLongES < 20 ? 'red' : 'var(--primary)'}">
              {resumenLongES}
            </span>
          </div>
        </div>
        <div class="form-wrap abstract" bind:this={divErrorResumenEn}>
          <textarea
            class="form-input"
            id="abstract-en"
            data-constraints="@Required"
            placeholder="Abstract"
            bind:value={articulo.abstract} />
          <div class="textareaLong" placeholder>
            <span
              style="color: {resumenLongEN < 20 ? 'red' : 'var(--primary)'}">
              {resumenLongEN}
            </span>
          </div>
        </div>

        <h4 class="subtitulo">
          Palabras Clave en Español ({articulo.palabrasClave.length})
        </h4>
        <Keywords
          bind:keywords={articulo.palabrasClave}
          placeholder="Palabra Clave" />

        <h4 class="subtitulo">
          Keywords in English ({articulo.keyWords.length})
        </h4>
        <Keywords bind:keywords={articulo.keyWords} placeholder="Keyword" />

        <h4 class="subtitulo">{dict['autores']} ({articulo.autores.length})</h4>
        <div class="buscarAutor">
          <div class="form-wrap">
            <input
              class="form-input"
              id="buscarAutores"
              placeholder={dict['buscarAutorEmail']}
              type="email"
              bind:value={buscarEmail} />
          </div>
          <div class="form-wrap">
            <div
              class="button button-sm button-primary botonBuscar"
              on:click={() => buscarUsuario()}>
              {dict['buscar']}
            </div>
          </div>
        </div>
        {#if searchError !== ''}
          <div
            class="alert alert-warning alert-dismissible fade show searchError"
            role="alert">
            {searchError}
            <button
              type="button"
              class="close"
              data-dismiss="alert"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        {/if}
        <div class="form-wrap crearAutor">
          <div
            class="button button-sm button-primary"
            on:click={() => showDialogCreateAuthor()}>
            {dict['nuevoAutor']}
          </div>
        </div>
        <table class="revista">
          {#each articulo.autores as autor, index}
            <AuthorItem
              {autor}
              first={index === 0}
              last={index === articulo.autores.length - 1}
              onUp={() => moveAuthor(index, index - 1)}
              onDown={() => moveAuthor(index, index + 1)}
              onRemove={() => removeAuthor(index)} />
          {/each}
        </table>

        <h4 class="subtitulo">{dict['manuscritoDoc']}</h4>
        <div class="info"><span>{dict['infoDocumentoDoc']}</span></div>
        <div class="form-group documento">
          <input
            id="manuscriptInputDoc"
            type="file"
            class="form-control-file"
            accept=".doc,.docx"
            on:change={() => addManuscriptDoc()} />
        </div>

        <h4 class="subtitulo">{dict['manuscritoPdf']}</h4>
        <div class="info"><span>{dict['infoDocumentoPdf']}</span></div>
        <div class="form-group documento">
          <input
            id="manuscriptInputPdf"
            type="file"
            class="form-control-file"
            accept=".pdf"
            on:change={() => addManuscriptPdf()} />
        </div>

        <h4 class="subtitulo">{dict['figuras']} ({articulo.figuras.length})</h4>
        <div class="info"><span>{dict['infoFiguras']}</span></div>
        {#if articulo.figuras.length > 0}
          <table class="revista">
            {#each articulo.figuras as figura, index}
              <FigureItem
                {figura}
                num={index + 1}
                first={index === 0}
                last={index === articulo.figuras.length - 1}
                onUp={() => moveFigure(index, index - 1)}
                onDown={() => moveFigure(index, index + 1)}
                onRemove={() => removeFigure(index)} />
            {/each}
          </table>
        {/if}
        <div class="form-wrap anadirFigura">
          <div
            class="button button-sm button-primary"
            on:click={() => showDialogAddFigure()}>
            {dict['nuevaFigura']}
          </div>
        </div>

        <div class="send">
          <div class="form-wrap">
            <div
              class="button button-lg button-primary"
              on:click={() => {
                if (!checkErrors()) {
                  dialogTitulo = dict['enviarArticulo'];
                  dialogText = dict['infoEnvio'];
                  aceptarAction = () => sendArticle();
                  window.$('#sendArticle').modal('show');
                }
              }}>
              {dict['enviar']}
            </div>
          </div>
        </div>
      </form>

      <!-- Versión 1 -->

      {#if documento1Info}
        <ArticleVersion
          idArticulo={articulo.id}
          fechaSolicitud={articulo.fechaSolicitud}
          documento={documento1Info}
          version={1}
          showInfo={true}
          figurasDoc={figurasDoc1}
          documentoFileDoc={documento1Doc}
          documentoFilePdf={documento1Pdf}
          miRol="AutorGestor"
          revisores={null}
          lettersAuthorsDoc={[]}
          lettersEditorsDoc={[]}
          showReviewers={false}
          collapsed={true} />

        <div class="tableEnd" />
      {/if}
    </div>
  </section>
  <Footer />
</div>
<div class="snackbars" id="form-output-global" />
<DialogCreateAuthor
  autor={newAutor}
  registerAuthor={() => registerAuthor()}
  errorMsg={errorMsgAutor} />
<DialogNewFigure figure={newFigure} addFigure={() => addFigure()} />
<AcceptCancelDialog
  id="sendArticle"
  titulo={dialogTitulo}
  tituloAceptar={dict['aceptarContinuar']}
  tituloCancelar={dict['cancelar']}
  {aceptarAction}
  text={dialogText} />
{#if loading}
  <LoadingDialog text={loadingText} />
{/if}
